var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.56505C1 8.9907 1 8.70352 1.07403 8.43905C1.1396 8.20478 1.24737 7.98444 1.39203 7.78886C1.55534 7.56806 1.78202 7.39175 2.23539 7.03912L9.0177 1.764C9.36902 1.49075 9.54468 1.35412 9.73865 1.3016C9.9098 1.25526 10.0902 1.25526 10.2613 1.3016C10.4553 1.35412 10.631 1.49075 10.9823 1.764L17.7646 7.03913C18.218 7.39175 18.4447 7.56806 18.608 7.78886C18.7526 7.98444 18.8604 8.20478 18.926 8.43905C19 8.70352 19 8.9907 19 9.56505V16.8C19 17.9201 19 18.4801 18.782 18.908C18.5903 19.2843 18.2843 19.5903 17.908 19.782C17.4802 20 16.9201 20 15.8 20H4.2C3.07989 20 2.51984 20 2.09202 19.782C1.71569 19.5903 1.40973 19.2843 1.21799 18.908C1 18.4801 1 17.9201 1 16.8V9.56505Z",
    stroke: "#",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.542a0c4776764384bc69e7f3aab57ec4.svg";
export { ForwardRef as ReactComponent };